import React, { useRef } from 'react';

import { Bloc } from '../../routes/project/components/step-drawer';
import { HistoryInput, HistoryInputRef } from '../history-input/history-input';

interface NumberInputProps {
  value: number;
  byStep?: number;
  label?: string;
  onChange: (value: number) => void;
  onKeyDown?: (e: any) => void;
  disabled?: boolean;
  required?: boolean;
  canNeg?: boolean;
  type?: string;
  min?: number;
  defaultValue?: number;
}

export const NumberInputDrawer: React.FC<NumberInputProps> = ({
  value,
  label,
  onChange,
  min = 1,
}) => {
  const inputRef = useRef<HistoryInputRef>(null);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    inputRef.current?.focus();
  };

  const handleChange = (value) => {
    onChange(parseFloat(value));
  };

  return (
    <Bloc onClick={handleClick}>
      <label>{label}</label>

      <HistoryInput
        ref={inputRef}
        value={value.toString()}
        onChange={handleChange}
        type={'number'}
        min={min}
      />
    </Bloc>
  );
};
